import { render, staticRenderFns } from "./validadorTratamientosCaja.vue?vue&type=template&id=117a880b&scoped=true"
import script from "./validadorTratamientosCaja.vue?vue&type=script&lang=js"
export * from "./validadorTratamientosCaja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117a880b",
  null
  
)

export default component.exports